<template>
  <div id="app">
    <transition name="fade" mode="out-in">
      <router-view v-if="isRouterAlive"/>
    </transition>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  name: "App",
  provide () {
    return {
      reload: this.reload
    }
  },
  data(){
    return {
      pannelWidth: null,
      isRouterAlive:true
    }
  },
  //app 文件判断是 pc端或者移动端
  methods: {
    _isMobile() {
      return this.$Utils.checkIsMobile();
    },
    changeIsMobileByWidthHeight(){
      let flag = this._isMobile()
      this.pannelWidth = document.body.clientWidth
      if (flag || (!flag && this.pannelWidth < 768)) {
        this.$store.commit('isMobile', true)
      }else{
        this.$store.commit('isMobile', false)
      }
    },
    reload () {
      this.isRouterAlive = false
      this.$nextTick(() => {
        this.isRouterAlive = true
      })
    }
  },
  computed: {
    ...mapGetters({
      isMobile: "getIsMobile"
    })
  },
  //根据判断后续处理 存储本地  移动端 为true pc端为false
  mounted() {
    this.changeIsMobileByWidthHeight();
    //实时获取屏幕宽度
    this.pannelWidth = document.body.clientWidth
    window.addEventListener('resize', () => this.changeIsMobileByWidthHeight());
  }
};

</script>
<style lang="postcss">
#app {

// 过渡动画
  & .fade-enter-active,
  & .fade-leave-active {
    transition: opacity 0.3s;
  }

  & .fade-enter,
  & .fade-leave-active {
    opacity: 0;
  }
}

::-webkit-scrollbar {
  -webkit-appearance: none;
  width: 13px;
  height: 13px;
}
::-webkit-scrollbar-track {
  background: rgba(0, 0, 0, 0.1);
  border-radius: 0;
}
::-webkit-scrollbar-thumb {
  cursor: pointer;
  border-radius: 1px;
  background: rgba(0, 0, 0, 0.15);
  transition: color 0.2s ease;
}
::-webkit-scrollbar-thumb:hover {
  background: rgba(0, 0, 0, 0.3);
}

.card_title{
  width:100px;
}


</style>
